import mergeProps from "@/router/utils/mergeProps.js";

let LoginView = () => import(/* webpackChunkName: "AuthFlow" */ '@/core/modules/Login/LoginView')
let SignupView = () => import(/* webpackChunkName: "AuthFlow" */ '@/core/modules/Login/RegisterScreen.vue')
let SignupSpecialInviteView = () => import(/* webpackChunkName: "AuthFlow" */ '@/core/modules/Login/RegisterSpecialInviteView')
let RecoverView = () => import(/* webpackChunkName: "AuthFlow" */ '@/core/modules/Login/RestoreAccessView.vue')
let EmptyRouterView = () => import(/* webpackChunkName: "AuthFlow" */ '@/core/components/EmptyRouterView.vue')


export default [
	{
		path: '/app',
		redirect: '/app/coaching/processes',
		component: EmptyRouterView,
		props: route => ({
			specialId: route.query.specialId
		}),
		meta:{
			isWhitelisted: true
		},
		children:[
			{
				path: 'login',
				name: 'Login',
				component: LoginView,
			},
			{
				path: 'recover',
				name: 'Recover',
				component: RecoverView,
			},

			{
				path: 'login-coach',
				name: 'LoginCoach',
				component: LoginView,
				props: route => ({
					specialId: route.query.specialId,
					isLoginCoach: true
				}),
			},
			{
				path: 'signup-coach',
				name: 'SignupCoach2',
				component: SignupView,
				props: mergeProps,
				meta: {
					isLoginCoach: true
				},
			},
			{
				path: 'signup',
				name: 'SignupCoach',
				component: SignupView,
				props: mergeProps,
				meta: {
					isLoginCoach: true
				},
			},
			{
				path: 'join/:teacherId',
				name: 'SignupTeacher',
				component: SignupView,
				props: mergeProps,
				meta: {
					isLoginCoach: true
				},
			},
			{
				path: 'signup-special-invite',
				name: 'SignupCoachSpecialInvite',
				component: SignupSpecialInviteView,
				props: route => ({
					specialId: route.query.specialId,
					isLoginCoach: true
				}),
			},
			{
				path: 'recover-coach',
				name: 'RecoverCoach',
				component: RecoverView,
				props: route => ({
					specialId: route.query.specialId,
					isLoginCoach: true
				}),
			},
		]
	},
	{
		path: '/app/login-coach-old',
		name: 'LoginCoachOld',
		redirect: {name: 'LoginCoach'},
		meta:{
			isWhitelisted: true
		}
	},



]
